
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/upland-waterfall",
      function () {
        return require("private-next-pages/destinations/upland-waterfall.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/upland-waterfall"])
      });
    }
  